import Scrollbar from "smooth-scrollbar";

class HorizontalScrollPlugin extends Scrollbar.ScrollbarPlugin {
	static pluginName = "horizontalScroll";

	transformDelta(delta, fromEvent) {
		if (!/wheel/.test(fromEvent.type)) {
			return delta;
		}

		const { x, y } = delta;

		return {
			y: 0,
			x: Math.abs(x) > Math.abs(y) ? x : y * 3,
		};
	}
}

const video_controls = () => {
	const videos = [...document.querySelectorAll("video")];
	const controls = [];
	videos.forEach((video, index) => {
		const control = new ControlsVideos(video, index);
		controls.push(control);
	});

	setupVideoVisibilityObserver(videos);
};
const setupVideoVisibilityObserver = (videos) => {
	const options = {
		root: null,
		rootMargin: "0px",
		threshold: [0, 1],
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (![...entry.target.classList].includes("is-controled")) {
				if (entry.isIntersecting) {
					entry.target.play();
				} else {
					entry.target.pause();
				}
			}
		});
	}, options);

	videos.forEach((video) => {
		observer.observe(video);
	});
};

class ControlsVideos {
	constructor(video, index) {
		this.handlerPlayPause = this.handlerPlayPause.bind(this);
		this.handlerFullscreen = this.handlerFullscreen.bind(this);
		this.handlerAudio = this.handlerAudio.bind(this);
		this.checkAudio = this.checkAudio.bind(this);

		this.DOM = video.parentNode;

		this.VIDEO = video;
		this.DOM.querySelector(".i-play").addEventListener(
			"click",
			this.handlerPlayPause
		);

		this.DOM.querySelector(".i-fullscreen").addEventListener(
			"click",
			this.handlerFullscreen
		);

		this.DOM.querySelector(".i-mute").addEventListener(
			"click",
			this.handlerAudio
		);

		this.checkAudio();
		this.audio = false;
		if (!this.audio) {
			this.DOM.querySelector(".audio").classList.add("not");
		}
	}
	handlerPlayPause() {
		if (this.VIDEO.paused) {
			this.VIDEO.play();
			this.VIDEO.classList.remove("is-controled");

			this.DOM.querySelector(".i-play").classList.add("hide");
			this.DOM.querySelector(".i-pause").classList.remove("hide");
		} else {
			this.VIDEO.pause();
			this.VIDEO.classList.add("is-controled");

			this.DOM.querySelector(".i-play").classList.remove("hide");
			this.DOM.querySelector(".i-pause").classList.add("hide");
		}
	}
	handlerFullscreen() {
		const fullscreenElement =
			document.fullscreenElement ||
			document.mozFullScreenElement ||
			document.webkitFullscreenElement ||
			document.msFullscreenElement;
		if (fullscreenElement) {
			exitFullscreen();
		} else {
			launchIntoFullscreen(this.VIDEO);
		}
	}
	handlerAudio() {
		if (!this.audio) {
			return false;
		}

		if (this.VIDEO.muted) {
			this.VIDEO.muted = false;
			this.DOM.querySelector(".i-mute").classList.add("hide");
			this.DOM.querySelector(".i-not-mute").classList.remove("hide");
		} else {
			this.VIDEO.muted = true;
			this.DOM.querySelector(".i-mute").classList.remove("hide");
			this.DOM.querySelector(".i-not-mute").classList.add("hide");
		}
	}
	checkAudio() {
		this.VIDEO.addEventListener("loadeddata", (e) => {
			if (typeof this.VIDEO.webkitAudioDecodedByteCount !== "undefined") {
				if (this.VIDEO.webkitAudioDecodedByteCount > 0) {
					this.audio = true;
				}
			} else if (typeof this.VIDEO.mozHasAudio !== "undefined") {
				if (this.VIDEO.mozHasAudio) {
					this.audio = true;
				}
			}
			if (this.audio) {
				this.DOM.querySelector(".audio").classList.remove("not");
			}
		});
	}
}
function hasAudio(video) {
	const audioTracks = video.webkitAudioDecodedByteCount;
	console.log(audioTracks);
	// return audioTracks.length > 0;
}
function launchIntoFullscreen(element) {
	if (element.requestFullscreen) {
		element.requestFullscreen();
	} else if (element.mozRequestFullScreen) {
		element.mozRequestFullScreen();
	} else if (element.webkitRequestFullscreen) {
		element.webkitRequestFullscreen();
	} else if (element.msRequestFullscreen) {
		element.msRequestFullscreen();
	} else {
		element.classList.toggle("fullscreen");
	}
}

function exitFullscreen() {
	if (document.exitFullscreen) {
		document.exitFullscreen();
	} else if (document.mozCancelFullScreen) {
		document.mozCancelFullScreen();
	} else if (document.webkitExitFullscreen) {
		document.webkitExitFullscreen();
	}
}

const gifs = () => {
	const allGifs = [...document.querySelectorAll(".gifs")];
	allGifs.forEach((gifs) => {
		const AnimGifs = new GifAnim(gifs);
	});
};
class GifAnim {
	constructor(gifs, index_active = 0) {
		this.anim(gifs, index_active);
	}
	anim(gifs, index_active) {
		const children = [...gifs.children];
		children.map((gif, index) => {
			if (index != index_active) {
				gif.classList.add("hide");
			} else {
				gif.classList.remove("hide");
			}
		});
		const next =
			index_active + 1 > children.length - 1 ? 0 : index_active + 1;
		setTimeout(() => {
			this.anim(gifs, next);
		}, 1500);
	}
}

const scrollingSpeed = 800;

document.documentElement.style.setProperty(
	"--scrollingSpeed",
	`${scrollingSpeed / 1000}s`
);

let sc = null;
if (document.querySelector(".single")) {
	Scrollbar.use(HorizontalScrollPlugin);

	if(window.innerWidth > 600){
		sc = Scrollbar.init(document.querySelector(".single .single-wrapper"), {
			damping: 0.08,
			delegateTo: document.documentElement,
		});
	
		sc.addListener((e) => {
			if (e.offset.x == e.limit.x) {
				if (!inNext) {
					clearTimeout(timerNextSection);
					timerNextSection = setTimeout(() => {
						go();
					}, 1500);
					inNext = true;
				}
			} else {
				clearTimeout(timerNextSection);
				inNext = false;
			}
	
			const winWidth = window.innerWidth;
	
			if (e.offset.x >= e.limit.x - winWidth) {
				document
					.querySelector(".single .titles__title")
					.classList.add("hide");
			} else {
				document
					.querySelector(".single .titles__title")
					.classList.remove("hide");
			}
	
			// Gris title
			if (e.offset.x >= winWidth - winWidth / 4) {
				document
					.querySelector(".single .titles__title")
					.classList.add("gray");
			} else {
				document
					.querySelector(".single .titles__title")
					.classList.remove("gray");
			}
		});
	}else{
		document.documentElement.classList.add('pourcent')
	}


	setTimeout(() => {
		document.querySelector(".single .titles-base").classList.add("hide");
	}, 200);

	video_controls();
	gifs();
}

let inNext = false;
let timerNextSection = null;
const elNextSection = document.querySelector("[meta-href]");
const go = () => {
	elNextSection.classList.add("active");
	setTimeout(() => {
		document.location.href = elNextSection.getAttribute("meta-href");
	}, 600);
};

let scrollY = 0

if(document.querySelector('.single')){
	document.body.addEventListener('scroll',(event) => {
		const doc = document.body;
	
		const docHeight = document.querySelector('.single-int').offsetHeight - window.innerHeight;
		scrollY = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)
	
		if(window.innerWidth <= 600){
			if ( scrollY == docHeight) {
				if (!inNext) {
					clearTimeout(timerNextSection);
					timerNextSection = setTimeout(() => {
						go();
					}, 1500);
					inNext = true;
				}
			} else {
				clearTimeout(timerNextSection);
				inNext = false;
			}
		}
	
	
	});
}
